import React from "react";
import i18next from "i18next";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { userService } from "../_services";
import { showGlobalSnackbar } from "../_services/snackbarService";

// Совпадает с правилом бэка (min:6), чтобы не гонять заведомо отклоняемый запрос
const MIN_LENGTH = 6;

export class PasswordDialog extends React.Component {
  state = { password: "", error: "", saving: false };

  componentDidUpdate(prevProps) {
    if (this.props.user && this.props.user !== prevProps.user) {
      this.setState({ password: "", error: "", saving: false });
    }
  }

  save = (e) => {
    e.preventDefault();
    const { password } = this.state;
    if (password.length < MIN_LENGTH) {
      this.setState({ error: i18next.t("the_password_must_be_6_characters") });
      return;
    }
    this.setState({ saving: true, error: "" });
    // 403 (суперюзер) и 422 показывает снеком сам patchWrapperBody
    userService.patchWrapperBody(
      `api/superuser/password/${this.props.user.id}`,
      { password },
      () => {
        showGlobalSnackbar(i18next.t("superuser_password_changed"), "success");
        this.props.onClose();
      },
      () => this.setState({ saving: false })
    );
  };

  render() {
    const { user, onClose } = this.props;
    const { password, error, saving } = this.state;

    return (
      <Dialog open={!!user} onClose={onClose}>
        <form onSubmit={this.save}>
          <DialogTitle>
            {i18next.t("superuser_change_password")}
            {user && <div style={{ fontSize: 14, wordBreak: "break-all" }}>{user.email}</div>}
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              fullWidth
              margin="dense"
              type="text"
              autoComplete="new-password"
              label={i18next.t("superuser_new_password")}
              value={password}
              error={!!error}
              helperText={error}
              onChange={(e) => this.setState({ password: e.target.value, error: "" })}
              style={{ width: "100%", maxWidth: 400 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>{i18next.t("btn_cancel")}</Button>
            <Button type="submit" disabled={saving}>{i18next.t("btn_save")}</Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
